export default __webpack_public_path__ + "static/media/baner4.28992c1e.png";